var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "site-team-page" },
    [
      _c(
        "div",
        { staticClass: "hero" },
        [
          _vm._m(0),
          _c(
            "el-button",
            { attrs: { size: "small" }, on: { click: _vm.openCreate } },
            [_vm._v("新增成员")]
          ),
        ],
        1
      ),
      _c(
        "el-card",
        {
          attrs: { shadow: "never", "body-style": { padding: "0 20px 20px" } },
        },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              attrs: { data: _vm.list, size: "mini" },
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "project.projectNo",
                  label: "工地编号",
                  "min-width": "140",
                },
              }),
              _c("el-table-column", {
                attrs: { prop: "staffName", label: "成员", width: "100" },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "member.projectRole",
                  label: "角色",
                  width: "100",
                },
              }),
              _c("el-table-column", {
                attrs: { prop: "member.status", label: "状态", width: "90" },
              }),
              _c("el-table-column", {
                attrs: { label: "操作", width: "180" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return _vm._l(row.actions, function (action) {
                        return _c(
                          "el-button",
                          {
                            key: action,
                            attrs: { type: "text", size: "mini" },
                            on: {
                              click: function ($event) {
                                return _vm.runAction(row, action)
                              },
                            },
                          },
                          [_vm._v(_vm._s(_vm.actionText(action)))]
                        )
                      })
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("span", [_vm._v("SITE TEAM")]),
      _c("h2", [_vm._v("装修团队")]),
      _c("p", [_vm._v("配置工长、设计师与工人。")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }